import { PremiumTiers } from '@bridebook/toolbox';

export const DEFAULT_VENUEREX_TIERS = [
  PremiumTiers.Tier_0,
  PremiumTiers.Tier_0_5,
  PremiumTiers.Tier_1,
  PremiumTiers.Tier_2,
  PremiumTiers.Tier_2_5,
  PremiumTiers.Tier_3,
  PremiumTiers.Tier_4,
];

export const RECOMMENDATIONS_ENGINE_VERSION = '2026-10-08-13-22-28';
